import { BIG_PARTY, type BigPartyScale } from '@somnhold/content';
import { idiv, imin, mulBp } from '../math/fixed.ts';

/**
 * A party table (bp or health by heroes, measured up to BIG_PARTY.measured) read for `n` heroes: past the
 * measured four, the fifth hero adds `extraBp` of the four's average hero and each one after it `rampBp` more.
 */
export const bigParty = (table: readonly number[], n: number, big: BigPartyScale = BIG_PARTY): number => {
  const m = BIG_PARTY.measured;
  if (n <= m) return table[n < 1 ? 1 : imin(n, table.length - 1)] as number;
  const four = table[m] as number;
  const k = n - m;
  // k heroes past four: k × extra, plus the ramp 0 + 1 + … + (k − 1).
  return four + mulBp(idiv(four, m), k * big.extraBp + idiv(k * (k - 1), 2) * big.rampBp);
};

/**
 * A party table for `n` heroes split into how many nightmares come (`count`, bp like the table) and how much
 * tougher each one is (`hpBp`). Up to the measured four it is the table and 10000; past that only
 * BIG_PARTY.countBp of the extra comes as more nightmares, the rest as health.
 */
export const crowd = (table: readonly number[], n: number, big: BigPartyScale = BIG_PARTY): { count: number; hpBp: number } => {
  const all = bigParty(table, n, big);
  const m = BIG_PARTY.measured;
  if (n <= m) return { count: all, hpBp: 10000 };
  const base = table[m] as number;
  const count = base + mulBp(all - base, BIG_PARTY.countBp);
  return { count, hpBp: idiv(all * 10000, count) };
};
